import { useMemo } from 'react'

import { useAccounts } from '@modules-deprecated/app/accounts'
import { useUserOrganization } from '@modules-deprecated/app/organization'

export const useDefaultCegidExpenseAccount = () => {
  const { organization } = useUserOrganization()
  const { accounts = [] } = useAccounts()

  const shouldUseDefaultExpenseAccount = organization?.countryId === 'FR' && organization?.isCegid
  const defaultPredefinedAccountId = 'NGZiOWY4MTRkNzZkNGFlYj' // Harcoded for cegid

  const defaultAccount = useMemo(() => {
    if (!shouldUseDefaultExpenseAccount || accounts.length === 0) {
      return undefined
    }
    return accounts.find((account) => account?.predefinedAccount?.id === defaultPredefinedAccountId)
  }, [shouldUseDefaultExpenseAccount, accounts, defaultPredefinedAccountId])

  return { defaultAccount, shouldUseDefaultExpenseAccount }
}
